/**
 * Sharp8 API · /api/v1/me fetcher.
 *
 * Returns the Telegram-verified user (or a guest user outside Telegram).
 * The mini-app sends Telegram's `initData` via the X-Telegram-Init-Data
 * header — the API verifies it via HMAC against TG_BOT_TOKEN.
 */

import type { User } from '@sharp8/types';
import { tg } from './telegram';

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';

export interface MeResponse {
  user: User;
  guest: boolean;
}

export async function fetchMe(): Promise<MeResponse> {
  const initData = tg()?.initData ?? '';
  const res = await fetch(`${API_BASE.replace(/\/$/, '')}/me`, {
    headers: initData ? { 'X-Telegram-Init-Data': initData } : {},
  });
  if (!res.ok) {
    throw new Error(`/me failed: ${res.status} ${res.statusText}`);
  }
  return (await res.json()) as MeResponse;
}
